import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import UtilityPageTemplate from '@templates/UtilityPageTemplate';
import { Details } from '@layout/ErrorBoundary';
import { Button } from '@atoms';
import { Whitespace } from '@layout';
import messages from './messages';

export class ErrorBoundary extends Component {
  static propTypes = {
    children: PropTypes.node.isRequired,
  };

  state = {
    error: null,
    details: null,
    revealDetails: false,
  };

  componentDidCatch(errorObj, errorInfo) {
    const error = errorObj.toString();
    const details = errorInfo.componentStack;
    this.setState({ error, details });
    this.props.logError(error, details);
  }

  render() {
    const { error, details, revealDetails } = this.state;

    return error ? (
      <UtilityPageTemplate title={<FormattedMessage {...messages.title} />}>
        <p>{error}</p>
        {revealDetails ? (
          <Details>{details}</Details>
        ) : (
          <Button onClick={() => this.setState({ revealDetails: true })}>
            <FormattedMessage {...messages.revealDetails} />
          </Button>
        )}
        <Whitespace size="1em" />
      </UtilityPageTemplate>
    ) : (
      this.props.children
    );
  }
}



// WEBPACK FOOTER //
// ./components/organisms/ErrorBoundary/ErrorBoundary.js